import { render, staticRenderFns } from "./PageAdvertise.vue?vue&type=template&id=47eb8eba&scoped=true"
import script from "./PageAdvertise.vue?vue&type=script&lang=js"
export * from "./PageAdvertise.vue?vue&type=script&lang=js"
import style0 from "./PageAdvertise.vue?vue&type=style&index=0&id=47eb8eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb8eba",
  null
  
)

export default component.exports